const seenPending = new Set<string>();
let primed = false;

function beep() {
  try {
    const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.frequency.value = 880;
    gain.gain.value = 0.05;
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + 0.18);
    window.setTimeout(() => void ctx.close(), 400);
  } catch {
    /* sound is optional */
  }
}

/** Sound and a browser notification the first time a pending order appears. */
export function alertOnNewPendingOrders(orders: { id: string; status?: string; order_number?: string }[]) {
  const pending = (orders || []).filter((order) => String(order.status || '').toLowerCase() === 'pending');
  if (!primed) {
    pending.forEach((order) => seenPending.add(order.id));
    primed = true;
    return;
  }
  const fresh = pending.filter((order) => !seenPending.has(order.id));
  pending.forEach((order) => seenPending.add(order.id));
  if (!fresh.length) return;
  beep();
  if (typeof Notification !== 'undefined') {
    if (Notification.permission === 'granted') {
      const first = fresh[0];
      const title = fresh.length === 1 ? 'New QahwaHub order' : `${fresh.length} new QahwaHub orders`;
      const body = first.order_number ? `Order ${first.order_number} is waiting.` : 'A new order is waiting.';
      try {
        new Notification(title, { body });
      } catch {
        /* ignore */
      }
    } else if (Notification.permission === 'default') {
      void Notification.requestPermission();
    }
  }
}
